import { AppBar, IconButton, Toolbar, Typography, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ticketEasyColors } from '../TicketEasyTheme';

interface TicketEasyAppBarProps {
    toggleDrawer: () => void;
}

const TicketEasyAppBar: React.FC<TicketEasyAppBarProps> = ({ toggleDrawer }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/ticketEasy/start');
    };

    return (
        <React.Fragment>
            <AppBar position="relative" sx={{ backgroundColor: ticketEasyColors.psnBlue, width: '100%' }}>
                <Toolbar 
                    sx={{ 
                        padding: 0,
                        minHeight: '56px',
                        width: '100%', 
                        maxWidth: 'none',
                        margin: 0,
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        boxSizing: 'border-box'
                    }}
                    disableGutters
                >
                    <IconButton 
                        edge="start" 
                        color="inherit" 
                        aria-label="menu" 
                        onClick={toggleDrawer}
                        sx={{ ml: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography 
                        variant="h6" 
                        color="white" 
                        sx={{ 
                            fontWeight: 600
                        }}
                    >
                        TicketEasy
                    </Typography>
                    <IconButton 
                        edge="end" 
                        color="inherit" 
                        aria-label="add" 
                        onClick={handleNavigate}
                        sx={{
                            mr: 2,
                            backgroundColor: ticketEasyColors.psnGreen,
                            '&:hover': {
                                backgroundColor: '#4ba9aa'
                            }
                        }}
                    >
                        <AddIcon />
                    </IconButton>                    
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
};

export { TicketEasyAppBar };